import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessingService {

  readonly message = signal<string | null>(null);

  show(message: string): void {
    this.message.set(message);
  }

  hide(): void {
    this.message.set(null);
  }
}
